import {
    doCreateUserWithEmailAndPassword,
    doSignInWithEmailAndPassword,
    doSignOut,
    fetchingUser,
} from '../../configs/environments/firebase/firebaseApp'

export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_USER = 'AUTH_USER';
export const LOAD_FILE = 'LOAD_FILE';
export const ADD_LAWYER = 'ADD_LAWYER';

//Actions
export function authUser() {
    return {
        type: AUTH_USER
    }
}

export function signOutUser() {
    return {
        type: SIGN_OUT_USER
    }
}

export function authError(error) {
    return {
        type: AUTH_ERROR,
        payload: error
    }
}

export function onFileLoaded(imageFile) {
    return {
        type: LOAD_FILE,
        payload: imageFile
    }
}

export function addingLawyer(data) {
    return {
        type: ADD_LAWYER,
        payload: data
    }
}

// signUpUser
export function signUpUser(credentials) {
    return function (dispatch) {
        doCreateUserWithEmailAndPassword(credentials.email, credentials.password)
            .then(response => {
                dispatch(authUser());
            })
            .catch(error => {
                dispatch(authError(error));
            });
    }
}
// signInUser
export function signInUser(credentials) {
    return function (dispatch) {
        doSignInWithEmailAndPassword(credentials.email, credentials.password)
            .then(response => {
                dispatch(authUser());
            })
            .catch(error => {
                dispatch(authError(error));
            });
    }
}

export function signOutUserCreator() {
    return function (dispatch) {
        doSignOut()
            .then(() => {
                dispatch({
                    type: SIGN_OUT_USER
                })
            });
    }
}

export function verifyAuth() {
    return function (dispatch) {
        fetchingUser(user => {
            if (user) {
                dispatch(authUser());
            } else {
                dispatch(signOutUser());
            }
        });
    }
}


